import {AMOUNTS_AGENCIES_REQUEST, AMOUNTS_AGENCIES_SHOW, AMOUNTS_AGENCIES_EDIT, AMOUNTS_AGENCIES_COMPLETE, AMOUNTS_AGENCIES_FAIL} from "../store/config";

const amountsAgenciesInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters:{
		q: '',
		modality_id: '',
		version_id: ''
	},
	permissions:[],
	edit: {},
	error: undefined,
	timestamp: undefined
}

const amounts_agencies = (state = amountsAgenciesInit, action) => {
	switch(action.type) {
		case AMOUNTS_AGENCIES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case AMOUNTS_AGENCIES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case AMOUNTS_AGENCIES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case AMOUNTS_AGENCIES_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case AMOUNTS_AGENCIES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default amounts_agencies;


// WEBPACK FOOTER //
// ./src/reducers/amounts_agencies.js